import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaxonomyModule } from '@app/modules/taxonomy/taxonomy.module';
import { PostAssignItemsDialogComponent } from './post-assign-items-dialog.component';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
    declarations: [PostAssignItemsDialogComponent],
    imports: [CommonModule, TaxonomyModule, SharedModule],
    exports: [PostAssignItemsDialogComponent],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PostAssignItemsModule {}
